export var almostEqual = function (a, b, threshold) {
    if (threshold === void 0) { threshold = 0.0001; }
    return Math.abs(a - b) < threshold;
};
/* Volume of a cylinder: h*π*r^2, multiply by 1000 for dm3
 * Assuming height & diameter are in m  */
export var getCylinderVolumeDm3 = function (height, diameter) {
    return Math.PI * Math.pow(diameter / 2, 2) * height * 1000;
};
export var trimModelName = function (name) {
    return name.replace(/(\.model)?(\.json)?(\.glb)?$/i, "");
};
// The suctionCupCompatibility and mountingCompatibility fields from tacton is a string, it exists on all cups and all mountings.
// That string needs to be the same for cup and mounting for them to be compatible.
// We only use this to filter mountings, cups won't be filtered. Instead we display a warning to the user if a newly selected cup no longer is compatible -
// with the currently selected mounting. The user is then prompted to change mounting.
export var ALWAYS_COMPATIBLE = "Always Compatible";
export var isMountingCompatibleWithSuctionCup = function (suctionCup, mounting) {
    if (!suctionCup || !mounting)
        return true;
    var mountingCompatibility = suctionCup.mountingCompatibility;
    var suctionCupCompatibility = mounting.suctionCupCompatibility;
    // The "none selection" of a cup or mounting is always compatibile with all.
    var isAlwaysCompatible = [
        suctionCupCompatibility,
        mountingCompatibility,
    ].some(function (compatibility) { return compatibility === ALWAYS_COMPATIBLE; });
    if (isAlwaysCompatible)
        return true;
    var isCompatible = suctionCupCompatibility === mountingCompatibility;
    return isCompatible;
};
